'use client'

import Menu2Icon from '@/assets/icons/menu-01.svg'
import { cn } from '@/core/lib/utils/cn'
import { HeadlineModel } from '@/features/blog/types/models/headline.model'
import { Drawer, DrawerBody, DrawerContent, useDisclosure } from '@heroui/react'
import { HeadlineList } from './list'

type Props = {
  headlines: HeadlineModel[]
  className?: string
}

export const HeadlineDrawer: React.FC<Props> = ({
  headlines,
  className = '',
}) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure()

  return (
    <div className={cn(className, 'h-5 w-5')}>
      <button onClick={onOpen}>
        <Menu2Icon className='fill-primary text-navy h-5 w-5' />
      </button>
      <Drawer
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        radius='sm'
        placement='left'
        size='xs'
        classNames={{
          closeButton: 'hidden',
        }}
      >
        <DrawerContent>
          {() => (
            <DrawerBody>
              <HeadlineList headlines={headlines} />
            </DrawerBody>
          )}
        </DrawerContent>
      </Drawer>
    </div>
  )
}
